import { useState, useEffect } from 'react';
import { getConfig } from '@purple-start-registration/common/registration';

export const useConfig = (section) => {
  const [config, setConfig] = useState();

  useEffect(async () => {
    if (config) {
      return;
    }

    const configSection = await getConfig(section);
    setConfig(configSection);
  });

  return {
    config,
  };
};
